module.exports = __webpack_public_path__ + "img/skillsB-1.f770615e.png";